import { registerCapability } from '../../platform/capability-registry';
import { MaasModelStorageBlock } from './MaasModelStorageBlock';
import { MAAS_MODEL_STORAGE_FIELD_KEY_LIST } from './fieldKeys';
import { resolveMaasModelStoragePaths } from './resolvePaths';
import type { MaasModelStorageBlockOptions } from './types';

registerCapability<MaasModelStorageBlockOptions>({
  key: 'maas-model-storage',
  fields: [...MAAS_MODEL_STORAGE_FIELD_KEY_LIST],
  component: MaasModelStorageBlock,
  defaultPaths: (prefix) => resolveMaasModelStoragePaths(prefix),
  resolvePaths: (prefix) => resolveMaasModelStoragePaths(prefix),
});
